import { Component, computed } from '@angular/core';
import { XMLElementBaseComponent } from '../../base';

@Component({
  selector: 'app-xml-table',
  standalone: true,
  template: `
    @if (hasContent()) {
      <table class="mb-4 min-w-full border-collapse">
        @for (group of data.children; track $index) {
          @if (group.tag === 'tgroup') {
            <!-- Table Header -->
            @for (section of group.children; track $index) {
              @if (section.tag === 'thead') {
                <thead class="bg-gray-100">
                  @for (row of section.children; track $index) {
                    <tr class="border-b border-gray-200">
                      @for (entry of row.children; track $index) {
                        <th
                          class="border border-gray-300 px-3 py-2 text-left text-sm font-medium"
                          [attr.rowspan]="getRowSpan(entry)"
                          [attr.colspan]="getColSpan(entry)">
                          @if (entry.text) {
                            {{ entry.text }}
                          }
                          @if (entry.children && entry.children.length > 0) {
                            <div [attr.data-entry-index]="$index" class="entry-container"></div>
                          }
                        </th>
                      }
                    </tr>
                  }
                </thead>
              }
              @if (section.tag === 'tbody') {
                <tbody>
                  @for (row of section.children; track $index) {
                    <tr class="border-b border-gray-200 hover:bg-gray-50">
                      @for (entry of row.children; track $index) {
                        <td class="border border-gray-300 px-3 py-2 text-sm" [attr.rowspan]="getRowSpan(entry)" [attr.colspan]="getColSpan(entry)">
                          @if (entry.text) {
                            {{ entry.text }}
                          }
                          @if (entry.children && entry.children.length > 0) {
                            <div [attr.data-entry-index]="getUniqueIndex(group, section, row, $index)" class="entry-container"></div>
                          }
                        </td>
                      }
                    </tr>
                  }
                </tbody>
              }
            }
          }
        }
      </table>
    }
  `,
})
export class TableComponent extends XMLElementBaseComponent {
  hasContent = computed(() => {
    const hasC = (data: any) => {
      if (!data) return false;
      if (data.text) return true;
      if (!data.children || data.children.length === 0) return false;
      return data.children.some(hasC);
    };

    return hasC(this.data);
  });

  getRowSpan(entry: any): number | null {
    const morerows = parseInt(entry.morerows);
    return isNaN(morerows) ? null : morerows + 1;
  }

  getColSpan(entry: any): number | null {
    void entry;
    // Could be calculated from colspec if needed
    return null;
  }

  getUniqueIndex(group: any, section: any, row: any, entryIndex: number): string {
    return `${group.cols || 'g'}-${section.tag}-${row.children?.indexOf(row) || 0}-${entryIndex}`;
  }
}
